import reducer from "./reducers";

import * as onboardingActions from "./actions";

export { onboardingActions };

export default reducer;
